import { useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// locales
import ThemeLocalization from './locales';
// components
import { StyledChart } from './components/chart';
import SnackbarProvider from './components/snackbar';
import { ThemeSettings } from './components/settings';
import { MotionLazyContainer } from './components/animate';
// Service
import { queryClient, persistWithIndexedDB } from './services/indexedDb';

export default function App() {
  // Ejecutar la persistencia de IndexedDB cuando la aplicación cargue
  useEffect(() => {
    persistWithIndexedDB(queryClient);
  }, []);

  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <ThemeSettings>
            <ThemeLocalization>
              <SnackbarProvider>
                <StyledChart />
                <Router />
              </SnackbarProvider>
            </ThemeLocalization>
          </ThemeSettings>
        </QueryClientProvider>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
